import styled from 'styled-components';

export const QuestionContent = styled.div`
  background: var(--color-surface);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: var(--color-text-muted);
  padding: 20px;
  width: 350px;
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 100;
  margin: 0 0 0 4px;

  :before {
    content: '';
    position: absolute;
    margin-left: -15px;
    border-width: 15px;
    border-style: solid;
    border-color: var(--color-surface) transparent transparent;
    top: -25px;
    left: 50%;
    z-index: 10000;
    transform: rotate(180deg);
  }

  ul {
    padding: 15px 0 0 17px;
    list-style: disc;

    li {
      padding: 0 0 0 2px;
    }
  }
`;
